
import WebService from "../WebService"
const Merchant = {
    gets() {
        return WebService.get("/merchants")
    },
    get_users(s, params) {
        return WebService.get("/merchants/" + s + '/users?' + params)
    },
    create(data, s) {
        return WebService.post(`/merchant?s=${s}`, data)
    },
    getMerchantDetail(id, s) {
        return WebService.get(`/merchant/${id}?s=${s}`)
    },
    updateMerchant(data, id) {
      return WebService.post(`merchant/${id}/update`, data)
    },
    uploadMerchant(data, e) {
      return WebService.post(`events/${e}/merchant/upload`, data)
    },
    getSeller(s, currentPage) {
        return WebService.get(`/merchants?s=${s}&page=${currentPage}`)
    },
}
export default Merchant
